import React from "react";
import { useNavigate } from "react-router-dom";
import { getFavorites } from "@/lib/storage";
import { getCalculator, CATEGORIES } from "@/lib/catalog";
import { Star, ChevronRight } from "lucide-react";

export default function Favorites() {
  const navigate = useNavigate();
  const ids = getFavorites();
  const items = ids.map(getCalculator).filter(Boolean);

  return (
    <div className="flex flex-col gap-5" data-testid="favorites-page">
      <section>
        <div className="font-mono-rs text-[10px] tracking-[0.22em] uppercase text-[var(--rs-amber)]">Quick Access</div>
        <h2 className="font-heading font-black text-3xl tracking-tight mt-1">Favorites</h2>
        <p className="text-sm text-[var(--rs-text-2)] mt-1.5">Your starred calculators.</p>
      </section>

      {items.length === 0 ? (
        <div className="card-rs p-6 text-center" data-testid="favorites-empty">
          <Star className="w-7 h-7 mx-auto text-[var(--rs-text-3)] mb-2" />
          <div className="text-sm text-[var(--rs-text-2)]">No favorites yet.</div>
          <div className="text-xs text-[var(--rs-text-3)] mt-1">Tap the star inside a calculator to add it.</div>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {items.map((c) => (
            <button
              key={c.id}
              data-testid={`fav-${c.id}`}
              onClick={() => navigate(`/calc/${c.id}`)}
              className="card-rs p-3.5 flex items-center justify-between text-left hover:border-[var(--rs-amber)] transition-colors"
            >
              <div className="min-w-0 pr-3">
                <div className="font-semibold text-sm">{c.name}</div>
                <div className="text-[11px] text-[var(--rs-text-3)] uppercase tracking-[0.1em] mt-0.5">
                  {CATEGORIES.find((x) => x.id === c.category)?.name}
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-[var(--rs-text-3)] shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
